<template>
    <div class="news-box">
        <h3 class="news-box-T">巅峰论鼻，索康协办广州鼻整形精英学术峰会</h3>
        <span class="news-box-text">
           6月24日，由中国中西医结合学会医学美容专业委员会鼻整形分会主办，广州华美医疗美容医院承办，上海索康·立秀膨体、立秀BEAUTYES国际研修中心协办的“2019年鼻整形新技术国家级继续教育项目学习班暨中国鼻整形新星手术案例PK大奖赛”（以下简称“大会”）在广州圆满落幕。
        </span>
        <div class="news-box-img-box">
            <img class="news-box-img" src="../../../../static/image/information/news02-M01.jpg">
        </div>
        <span class="news-box-text">
            作为2019年国内鼻部整形领域的高、精、尖学术交流盛会，大会汇聚了行业权威的鼻整形专家领袖，他们就鼻部整形及修复重建的临床及基础研究、新技术、新成果等方面进行了广泛深入的交流和探讨，给与会专家学员带来了鼻整形的前沿技术和成熟经验。         </span>
        <div class="news-box-img-box">
            <img class="news-box-img" src="../../../../static/image/information/news02-M02.png">
        </div>
        <span class="news-box-text">
            会议上，鼻整形大咖们就鼻部整形领域所取得的临床科研成果进行了现场分享。上海索康医用材料有限公司董事长叶明先生在大会上发表了《膨体材料并发症讨论》的课题演讲，就大家普遍关心的问题作出了解答，其中提到膨体材料不会缩水，但受到外界压力时可能导致体积缩小，故隆鼻、隆颏手术等建议使用加强型材料。同时指出膨体材料完全可以方便的取出，只是需要采用钝性剥离或环形剥离的方式。在谈到膨体材料是否很容易感染时，叶明董事长强调说：“膨体感染和材料本身关系不大，主要取决于手术技巧，如果严格遵循无菌操作规程、无张力填充等操作，膨体感染是可以避免的。”        </span>
        <div class="news-box-img-box">
            <img class="news-box-img" src="../../../../static/image/information/news02-M03.jpg">
        </div>
        <span class="news-box-text">
            上海索康医用材料有限公司是从事膨体聚四氟乙烯医用植入材料研发和生产的专业型企业，公司的拳头产品“立秀”，自面世至今已有14年历史，拥有超过50万例的临床应用。近几年，索康面对消费升级以及消费的时尚化需求，先后推出了高端定制品牌曼姝，时尚品牌AINOSE，获得求美者一致的信赖和好评。作为推动国内膨体聚四氟乙烯医用植入材料普及和应用的企业，叶明董事长提出，希望用规范化的膨体材料操作流程，彻底解决膨体材料并发症问题，并提出3年内膨体材料成为隆鼻材料主力军，市场覆盖达到80%的美丽愿景。相信随着技术进步及经验普及，这一美丽愿景定能实现！
        </span>
    </div>
</template>

<script>
export default {
  name: "new02"
}
</script>

<style scoped>
    .news-box {
        width: 100%;
        font-family: SY-Light;
    }

    .news-box-T {
        text-align: center;
    }

    .news-box-img {
        width: auto;
        max-width: 100%;
        height: auto;
    }

    .news-box-img-box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 30px 0;
    }

    .news-box-text {
        line-height: 25px;
    }
</style>
